import request from '@/utils/request'

// 发送短信
export function smsSend(params) {
  return request({
    url: '/api/sms/send',
    method: 'get',
    params
  })
}

// 获取用户信息
export function getUserInfo(params) {
  return request({
    url: '/api/user/info',
    methods: 'get',
    params
  })
}

// 获取待发布作品个数
export function getWaitMusicCount(params) {
  return request({
    url: '/api/publish/waitcount',
    methods: 'get',
    params
  })
}


// 实名认证接口
export function getRealidcation(data) {
  return request({
    url: '/api/realidcation/verifyurl',
    method: 'post',
    data
  })
}

// 撤销实名认证接口
export function undoRealidcation(param) {
  return request({
    url: '/api/realidcation/undo',
    method: 'get',
    param
  })
}



// 完成实名认证
export function finishedChildInfo(data) {
  return request({
    url: '/api/realidcation/sendnonage',
    method: 'post',
    data
  })
}

// 获取未成年人填写信息
export function getRealidcationInfo(params) {
  return request({
    url: '/api/realidcation/info',
    method: 'get',
    params
  })
}


// 获取消息列表
export function getSystemMessage(params) {
  return request({
    url: '/api/message/getlist',
    method: 'get',
    params
  })
}

// 获取新消息数量
export function getSystemMessageCount(params) {
  return request({
    url: '/api/message/count',
    method: 'get',
    params
  })
}

// 上传头像
export function uploadAvator(data) {
  return request({
    url: '/api/common/upload',
    method: 'post',
    data
  })
}

// 消息已读
export function setMessageRead(params) {
  return request({
    url: '/api/message/read',
    method: 'get',
    params
  })
}

// 消息全读
export function setMessageReadAll(params) {
  return request({
    url: '/api/message/readall',
    method: 'get',
    params
  })
}

// 获取阿里云密钥
export function getAliyunOssSecret(params) {
  return request({
    url: '/api/aliyun/osssecret',
    method: 'get',
    params
  })
}

// 获取开户行列表
export function getBankList(params) {
  return request({
    url: '/api/bill/banktype',
    method: 'get',
    params
  })
}

// 获取银行卡信息
export function getBankInfo(params) {
  return request({
    url: '/api/bill/bankinfo',
    method: 'get',
    params
  })
}

// 银行卡绑定
export function bankmation(params) {
  return request({
    url: '/api/bill/bankmation',
    method: 'get',
    params
  })
}

// 提现到银行卡
export function withdraw(data) {
  return request({
    url: '/api/bill/sure',
    method: 'post',
    data
  })
}

// 提现记录列表
export function withdrawList(data) {
  return request({
    url: '/api/bill/grandtotal',
    method: 'post',
    data
  })
}


// 修改个人信息
export function updateInfo(data) {
  return request({
    url: '/api/user/profile',
    method: 'post',
    data
  })
}

// 重置当前密码
export function resetPwd(data) {
  return request({
    url: '/api/user/resetpwd',
    method: 'post',
    data
  })
}

// 用户登出接口
export function logout(params) {
  return request({
    url: '/api/user/logout',
    method: 'get',
    params
  })
}

// 获取分类
export function getCategory(params) {
  return request({
    url: '/api/cms/Data/category',
    method: 'get',
    params
  })
}

// 获取分类详情
export function getCategoryInfo(params) {
  return request({
    url: '/api/cms/data/category_type',
    method: 'get',
    params
  })
}

// 获取发行数量
export function getMusicCount(params) {
  return request({
    url: '/api/album/get_user_stat',
    method: 'get',
    params
  })
}

// 提交反馈
export function submitProblem(data) {
  return request({
    url: '/api/problem/add_pro',
    method: 'post',
    data
  })
}

// 获取首页信息
export function getHomeData(data) {
  return request({
    url: '/api/app.cpuser/get_index_data',
    method: 'post',
    data
  })
}

// 获取配置文件
export function getConfig(data) {
  return request({
    url: '/api/web/get_config',
    method: 'post',
    data
  })
}

// 获取版本更新列表接口
export function getVersionInfo(data) {
  return request({
    url: '/api/softversion/getversion',
    method: 'post',
    data
  })
}


// 发布作品下拉选项
// 列表名称：all、语言、作品性质、流派、艺术性质、节拍、场景
export function getSelectList(params) {
  return request({
    url: '/api/publish/env',
    method: 'get',
    params
  })
}
